import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateConfirmationPayloadItem } from '@cashier/cashier-data-access';
import {
  FieldControlApi,
  FormField,
  ValidatorTypes,
} from '@cashier/cashier-model';
import { FieldValidator } from '@cashier/cashier-shared';

interface TouchFieldContext {
  interactionCompleted: boolean;
  source?: FieldControlApi;
}

interface UseFieldToucher {
  touch: (field: FormField, context: TouchFieldContext) => void;
}

export const useFieldToucher = (): UseFieldToucher => {
  const dispatch = useDispatch();

  const touch = useCallback(
    (field: FormField, context: TouchFieldContext) => {
      const { name, value } = field;
      const { interactionCompleted } = context;

      const validationReport = FieldValidator[ValidatorTypes.COMMON](field);

      dispatch(
        updateConfirmationPayloadItem({
          name,
          fieldPayload: {
            value,
            validationStatus: validationReport.status,
            interactionCompleted,
            errors: validationReport.errors,
          },
        }),
      );
    },
    [dispatch],
  );
  return { touch };
};
